import "core-js/modules/es.array.fill";
import "core-js/modules/es.array.map";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.to-string";
import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import { pickHTMLProps } from 'pick-react-known-prop';
import ProductListPagerClassicPaginationButton from './ProductListPagerClassicPaginationButton';

var range = function range(lo, hi) {
  return function (l, h) {
    return Array(h - l).fill(null).map(function ($, i) {
      return i + l;
    });
  }(hi > lo ? [lo, hi] : [hi, lo]);
};

var useStyles = makeStyles(function () {
  return {
    root: {},
    paginationButton: {}
  };
}, {
  name: 'SxComProductListPagerClassicPageList'
});

function ProductListPagerClassicPageList(_ref) {
  var pClasses = _ref.classes,
      className = _ref.className,
      fullWidth = _ref.fullWidth,
      getPageListWidth = _ref.getPageListWidth,
      lowerLimit = _ref.lowerLimit,
      onChangePage = _ref.onChangePage,
      page = _ref.page,
      upperLimit = _ref.upperLimit,
      rest = _objectWithoutProperties(_ref, ["classes", "className", "fullWidth", "getPageListWidth", "lowerLimit", "onChangePage", "page", "upperLimit"]);

  var classes = useStyles({
    classes: pClasses
  });
  var ref = React.useRef(null);
  React.useEffect(function () {
    getPageListWidth(ref.current.clientWidth);
  }, [getPageListWidth]);
  return /*#__PURE__*/React.createElement("div", _extends({
    ref: ref
  }, pickHTMLProps(rest), {
    className: clsx(classes.root, className)
  }), range(lowerLimit, upperLimit).map(function (p) {
    return /*#__PURE__*/React.createElement(ProductListPagerClassicPaginationButton, {
      className: classes.paginationButton,
      key: p.toString(),
      pageIndex: p,
      onChangePage: onChangePage,
      highlighted: p === page,
      fullWidth: fullWidth
    });
  }));
}

ProductListPagerClassicPageList.propTypes = {
  classes: PropTypes.shape({
    paginationButton: PropTypes.string,
    root: PropTypes.string
  }),
  className: PropTypes.string,
  fullWidth: PropTypes.bool,
  getPageListWidth: PropTypes.func.isRequired,
  lowerLimit: PropTypes.number.isRequired,
  onChangePage: PropTypes.func.isRequired,
  page: PropTypes.number.isRequired,
  upperLimit: PropTypes.number.isRequired
};
ProductListPagerClassicPageList.defaultProps = {
  classes: undefined,
  className: undefined,
  fullWidth: undefined
};
export default ProductListPagerClassicPageList;